import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import modules from './modules'

const vuexSession = new VuexPersistence({
  storage: window.localStorage,
  modules:['user']
})
const plugins = [vuexSession.plugin]
Vue.use(Vuex)
const store = new Vuex.Store({modules, plugins})

export default store
